<template>
  <div>
    <el-row type="flex" justify="end">
      <el-col :span="2">
        <el-button
          type="info"
          round
          @click="OpenInactivatedHistoric"
          icon="el-icon-notebook-2"
          >Historico</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <authorizerServices
        v-if="authorizerData != undefined"
        :authorizerData="authorizerData"
        @rechargingServices="GetInactiveSemaphoreData"
      />
    </el-row>
    <servicesSelector
      ref="ServicesSelector"
      :makeServicesSelectorVisible="makeServicesSelectorVisible"
      :authorizerData="authorizerData"
      @OnCloseServicesSelector="onCloseServicesSelector($event)"
      @rechargingServices="GetInactiveSemaphoreData"
      @ServicesCount="GetservicesCount"
    />

    <el-row type="flex" justify="center">
      <el-col :span="2">
        <el-badge :value="servicesCount" class="itemBadge" type="info">
          <el-button
            type="info"
            circle
            @click="addNewService"
            icon="el-icon-plus"
          ></el-button>
        </el-badge>
      </el-col>
    </el-row>

    <SemaphoreHistoric
      :makeHistoricVisible="makeHistoricVisible"
      @onHistoricClose="onHistoricClose"
    />
    <!--
    <el-row>
      <rabbey-table-3
        :loading="loadingAuthorizerData"
        :data="authorizerData"
        :columns="authorizerColumns"
        :actions="authorizerActions"
        @rtable-push-action="authorizerActionHandler"
      />
    </el-row>
    -->
    <!--
    <InactivationForm
      :makeItVisible="makeInactivationFormVisible"
      @oncloseInactivationForm="oncloseInactivationForm"
      @rechargingServices="GetInactiveSemaphoreData"
    />
    -->
  </div>
</template>

<script>
//import { IsInRole } from "@/utils";
import {
  SwitcherColumns,
  SwitcherActions
} from "@/views/modules/authorizer/switcher/columns/switcherColumns.js";
//import InactivationForm from "@/views/modules/authorizer/switcher/InactivationForm/InactivationForm.vue";
import authorizerServices from "@/views/modules/authorizer/switcher/authorizerServices/authorizerServices.vue";
import servicesSelector from "@/views/modules/authorizer/switcher/authorizerServices/servicesSelector.vue";
import SemaphoreHistoric from "@/views/modules/authorizer/switcher/Historic/SemaphoreHistoric.vue";
//import Type from '@/models/deals/Type';

export default {
  name: "Switcher",
  components: {
    //InactivationForm,
    authorizerServices,
    servicesSelector,
    SemaphoreHistoric
  },
  data() {
    return {
      //makeInactivationFormVisible: false,
      makeHistoricVisible: false,
      makeServicesSelectorVisible: false,
      loadingAuthorizerData: false,
      authorizerData: [],
      servicesCount: 0,
      /*
            [
                {
                    ServiceName: "MAGYPAGO",
                    CreateAt: "2023/01/01",
                    Actived: true,
                    InactiveAt: "2023/01/01",
                    MessageTerminal: "Mensaje que estara mostrado en las terminales",
                    Reason: " la razon porque que esta inactivando el servicio"

                },
                {
                    ServiceName: "NCFMOVIL",
                    CreateAt: "2023/01/01",
                    Actived: true,
                    InactiveAt: "2023/01/01",
                    MessageTerminal: "Mensaje que estara mostrado en las terminales",
                    Reason: " la razon porque que esta inactivando el servicio"

                },
                {
                    ServiceName: "FIDELIZACION",
                    CreateAt: "2023/01/01",
                    Actived: false,
                    InactiveAt: "2023/01/01",
                    MessageTerminal: "Mensaje que estara mostrado en las terminales",
                    Reason: " la razon porque que esta inactivando el servicio"

                },
                {
                    ServiceName: "TICKET",
                    CreateAt: "2023/01/01",
                    Actived: false,
                    InactiveAt: "2023/01/01",
                    MessageTerminal: "Mensaje que estara mostrado en las terminales",
                    Reason: " la razon porque que esta inactivando el servicio"

                }
            ],
            */
      authorizerColumns: SwitcherColumns,
      authorizerActions: SwitcherActions
    };
  },
  created() {
    this.GetInactiveSemaphoreData();
    //this.$refs.ServicesSelector.GetSemaphoreServices()
  },
  mounted() {
    //this.$refs.ServicesSelector.GetSemaphoreServices()
  },
  methods: {
    async GetInactiveSemaphoreData() {
      this.loadingAuthorizerData = true;
      await this.$http
        .get("/api/tennos/GetAuthorizerSemaphore")
        .then((resp) => {
          //console.log("respuesta de data del semaforo: ", resp);
          this.authorizerData = resp.data;
        })
        .catch((err) => {
          console.error("Error: ", err);
        })
        .finally(() => {
          this.loadingAuthorizerData = false;
        });
      this.$refs.ServicesSelector.GetSemaphoreServices();
    },
    GetservicesCount(count) {
      this.servicesCount = count;
    },
    authorizerActionHandler(action) {
      //console.log("entro a authorizerActionHandler");
      //console.log("authorizerActionHandler action: ", action);
      switch (action.command) {
        case "activate":
          if (this.IsInRoles([this.roles.AdministradorDeAuthorizador])) {
            //console.log("activate");
            this.$confirm(
              `Esta a punto de reactivar el servicio ${action.row.ServiceName}. Desea continuar?`,
              "Cuidado",
              {
                confirmButtonText: "Continuar",
                cancelButtonText: "Cancelar",
                type: "warning"
              }
            )
              .then(() => {
                this.ReactivateService(action.row);
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: `Ha cancelado la reactivacion del servicio ${action.row.ServiceName}`
                });
              });
          } else {
            this.$message.error(
              "Usted no tiene los permisos nescesarios para realizar esta accion"
            );
          }

          break;

        default:
          break;
      }
    },
    ReactivateService(row) {
      //console.log("ReactivateService row: ", row);
      row.Actived = true;
      this.$http
        .put("/api/tennos/ReactivateAuthorizerService", row)
        .then(() => {
          //console.log(resp);
          this.$message({
            type: "success",
            message: `Servicio ${row.ServiceName} reactivado con exito`
          });
          this.GetInactiveSemaphoreData();
        })
        .catch((err) => {
          console.error("error al reactivar el servicio: " + err);
        });
    },
    /*
    InactivateNewService() {
      if (this.IsInRoles([this.roles.AdministradorDeAuthorizador])) {
        this.makeInactivationFormVisible = true;
      } else {
        this.$message.error(
          "Usted no tiene los permisos nescesarios para realizar esta accion"
        );
      }
    },
    */
    /*
    oncloseInactivationForm() {
      //console.log("oncloseInactivationForm closing dialog", form);
      this.makeInactivationFormVisible = false;
    },
    */
    addNewService() {
      if (this.IsInRoles([this.roles.AdministradorDeAuthorizador])) {
        this.makeServicesSelectorVisible = true;
      } else {
        this.$message.error(
          "Usted no tiene los permisos nescesarios para realizar esta accion"
        );
      }
    },
    onCloseServicesSelector(val) {
      //console.log("valor closing servicesSelector: ", val);
      this.makeServicesSelectorVisible = val;
    },
    OpenInactivatedHistoric() {
      this.makeHistoricVisible = true;
    },
    onHistoricClose(val) {
      this.makeHistoricVisible = val;
    }
  }
};
</script>

<style scoped>
.itemBadge {
  margin-left: 0px;
  margin-bottom: 0px;
  padding-left: 0px;
  padding-bottom: 0px;
}
</style>
